<template>
  <svg width="16" height="14" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M13 0H14.5C15.2529 0 16.0003 0.552927 16.0003 1.35293V3H0V1.5C0 0.7 0.794118 0 1.5 0H3V1C3 1.28235 3.26471 1.5 3.5 1.5C3.73529 1.5 4 1.28235 4 1V0H12V1C12 1.28235 12.2647 1.5 12.5 1.5C12.7353 1.5 13 1.28235 13 1V0ZM0 12.647V4H16.0003V12.647C16.0003 13.447 15.2529 14 14.5 14H1.5C0.747059 14 0 13.4941 0 12.647ZM2 6.5C2 6.22386 2.22386 6 2.5 6H3.5C3.77614 6 4 6.22386 4 6.5V7.5C4 7.77614 3.77614 8 3.5 8H2.5C2.22386 8 2 7.77614 2 7.5V6.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H3.5C3.77614 10 4 10.2239 4 10.5V11.5C4 11.7761 3.77614 12 3.5 12H2.5C2.22386 12 2 11.7761 2 11.5V10.5ZM7.5 6C7.22386 6 7 6.22386 7 6.5V7.5C7 7.77614 7.22386 8 7.5 8H8.5C8.77614 8 9 7.77614 9 7.5V6.5C9 6.22386 8.77614 6 8.5 6H7.5ZM7 10.5C7 10.2239 7.22386 10 7.5 10H8.5C8.77614 10 9 10.2239 9 10.5V11.5C9 11.7761 8.77614 12 8.5 12H7.5C7.22386 12 7 11.7761 7 11.5V10.5ZM12.5 6C12.2239 6 12 6.22386 12 6.5V7.5C12 7.77614 12.2239 8 12.5 8H13.5C13.7761 8 14 7.77614 14 7.5V6.5C14 6.22386 13.7761 6 13.5 6H12.5Z"
          fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconCalendar"
}
</script>

<style scoped>

</style>